export default {
  tipoDoc: 'Documento de identificación',
  nroDoc: 'Número de documento',
  nombres: 'Nombres',
  primerAp: 'Primer apellido',
  segundoAp: 'Segundo apellido',
  telefono: 'Número de teléfono móvil',
  email: 'Correo electrónico',
  nacionalidad: 'Nacionalidad',
  nro_legalizacion: 'Número de legalización',
  cod_seguridad: 'Código de seguridad',
  codigo: 'Código de seguimiento',
  day: 'Día',
  month: 'Mes',
  year: 'Año',
  nombre_solicitante: 'Nombre del titular del documento',
  nombre_apoderado: 'Nombre del apoderado',
  precio: 'Precio',
  fecha_expedicion: 'Fecha de expedición de la legalización/certificación',
  fecha_nacimiento: 'Fecha de nacimiento',
  docFactura: 'Número de documento',
  tipoFactura: 'Tipo de documento',
  nombreFactura: 'Nombre completo',
  estado: 'ESTADO',
  fecha_solicitud: 'Fecha de solicitud (es)',
  det_tramite: 'Detalles de su trámite',
  info_sol: 'TITULAR DEL DOCUMENTO',
  info_doc: 'DOCUMENTO(S)',
  info_doc_adjuntar: 'ADJUNTAR ARCHIVO(S)',
  info_pago: 'DATOS DE PAGO',
  info_finalizado: 'FINALIZADO',
  info_cont: 'Ingrese sus datos personales y de contacto para recibir notificaciones sobre el estado de su trámite.',
  info_email: 'Por favor verifique que la información obtenida que sea correcta y corresponda al titular autenticado por la plataforma de Ciudadania Digital.',
  info_agregar: 'Agregue el/los documento(s) que necesita legalizar/certificar',
  alert_doc: 'Todavía no tiene ningún documento agregado',
  mis_doc: 'Mis documentos',
  total: 'Total',
  agregar: 'Agregar',
  eliminar: 'Eliminar',
  costo: 'Costo',
  desc_doc: 'Descripción del/de los documento(s)',
  select_doc: 'Seleccione un documento para legalizar/certificar',
  select_gestion: 'Año de emisión del documento',
  doc: 'Documento',
  docs: 'Documentos',
  titulo_factura: 'Ingrese sus datos para la factura',
  datos_pago: 'Verifique los datos de pago. La factura solo cubre el pago de la(s) legalizacion(es)',
  titular_factura: 'Señor(es)',
  costo_doc: 'Costo de documento(s)',
  costo_total: 'Costo total: ',
  costo_legalizacion: 'Costo legalizacion(es)',
  confirmacion_solicitud: '¿Está seguro que quiere realizar su solicitud con estos datos? <br /> Revise bien los datos antes de continuar.',
  confirmar: 'Confirmar',
  aceptar: 'Aceptar',
  cancelar: 'Cancelar',
  fin_solicitud: '¡Su solicitud ha sido realizada correctamente!',
  cod_seguimiento: 'Su código de seguimiento es:',
  guardar_codigo: 'Guarde el código',
  seguimiento_codigo: ' de seguimiento para ver el estado de su solicitud ingresando ',
  aqui: '-> AQUÍ',
  ingrese_codigo_seguimiento: 'Ingrese el código de seguimiento para ver el estado de su trámite.',
  verificar_documento: 'Ingrese la información requerida para verificar que el documento se encuentre legalizado/certificado.',
  datos_del_solicitante: 'Datos del solicitante',
  pago_entidad: 'Pagado en la entidad',
  pago_minedu: 'Pagado en MINEDU',
  regional: 'Regional',
  tipoSolicitud: 'Tipo de solicitud',
  motivo: 'Destino del trámite',
  select_departamento: 'Seleccione el departamento donde realiza su trámite',
  confirmacion_apoderado: '¿Es usted el Titular de los documentos a legalizar/certificar o es un Apoderado?',
  soy_titular: 'SOY TITULAR',
  soy_apoderado: 'SOY APODERADO',
  espesifique_motivo: 'Por favor, especifique el motivo y entidad donde presentará el documento (max 200 caracteres). Ejm. Tramitación de Título - NOMBRE DE LA INSTITUCIÓN ',
  adjunto: 'Por favor, adjunte el documento que desea certificar/legalizar en formato PDF',
  adjuntar: 'Arrastre su archivo PDF aquí o haga click para seleccionarlo',
  cargando: 'Guardando ...',
  cargado: 'Archivo cargado',
  nota: 'NOTA:',
  nota_contenido: 'Por favor adjunte el documento que desea que sea procesado para los siguientes trámites, su solicitud NO será procesada si los adjuntos no fueron completados',
  nota_contenido_2: 'Es necesario que usted se haga presente en las oficinas del Ministerio de Educación, portando los documentos originales correspondientes a los adjuntos. Caso contrario, el trámite no podrá tener continuidad.',
  adjunto_ok: 'Archivo cargado correctamente',
  gestion: 'Gestión',
  tramitador_nroDoc: 'Número de documento',
  vigencia_documento: 'Vigencia del documento legalizado/certificado'
};



// WEBPACK FOOTER //
// ./src/lang/es/fields.js